import { useContext } from "react";
import { Pane } from "components/materials";
import { ScopeOrganizations } from "components/containers";
import { OrganizationSelector } from "components/templates";
import { majorScale, ThemeContext } from "helpers/utilities";
import { PERMISSION_ACTION } from "helpers/enums";
import { InsightCards } from "./InsightCards/InsightCards";

export function PortfolioInsights({ history }) {
  const theme = useContext(ThemeContext);
  return (
    <ScopeOrganizations scopeToUserPermission={PERMISSION_ACTION.RUN_REPORT}>
      {({
        onOrganizationSelected,
        allOrganizations,
        disabledOrganizations,
        selectedOrganization,
      }) => {
        return (
          <Pane backgroundColor={theme.colors.backgroundGray}>
            {allOrganizations.length > 1 && (
              <Pane padding={majorScale(2)}>
                <OrganizationSelector
                  onOrganizationSelected={onOrganizationSelected}
                  disabledOrganizations={disabledOrganizations}
                  organizations={allOrganizations}
                  selectedOrganization={selectedOrganization}
                  title="Viewing portfolio for"
                />
              </Pane>
            )}
            <Pane
              width="100%"
              height="auto"
              display="flex"
              paddingTop={majorScale(2)}
              justifyContent="center"
            >
              <Pane
                width="90%"
                maxWidth={1440}
                paddingBottom={majorScale(2)}
                paddingLeft={majorScale(2)}
                paddingRight={majorScale(2)}
              >
                <InsightCards
                  organization={selectedOrganization}
                  allOrganizations={allOrganizations}
                  disabledOrganizations={disabledOrganizations}
                  history={history}
                />
              </Pane>
            </Pane>
          </Pane>
        );
      }}
    </ScopeOrganizations>
  );
}
